/**
 * Api error codes reported by the Court System controller
 */
export var CourtSystemErrorCode;
(function (CourtSystemErrorCode) {
    /**
     * The AWS region specified for storage of court system's assets (TRMs, FLS files, etc)
     * is not supported by this environment
     */
    CourtSystemErrorCode["InvalidCourtRegion"] = "court-system/InvalidCourtRegion";
    /**
     * Indicates an attempt to create a court system with details that already exist.
     * @type {string}
     */
    CourtSystemErrorCode["AlreadyExists"] = "court-system/AlreadyExists";
    /**
     * Indicates an attempt to rename a court system to a name that already exists in another court system.
     * @type {string}
     */
    CourtSystemErrorCode["NameAlreadyExists"] = "court-system/NameAlreadyExists";
    /**
     * Indicates a user does not have an account for For The Record.
     */
    CourtSystemErrorCode["UserNotFound"] = "court-system/UserNotFound";
    /**
     * If the user is the last user/group administrator in a court, they cannot be removed.
     */
    CourtSystemErrorCode["UserCannotBeRemovedFromCourtSystem"] = "court-system/UserCannotBeRemovedFromCourtSystem";
    /**
     * Attempted to publish a court system configured with a test payment key.
     */
    CourtSystemErrorCode["CourtSystemConfiguredWithTestPaymentKey"] = "court-system/CourtSystemConfiguredWithTestPaymentKey";
    /**
     * Attempted to update the court system's time zone to an unsupported one.
     */
    CourtSystemErrorCode["UnsupportedTimeZone"] = "court-system/UnsupportedTimeZone";
})(CourtSystemErrorCode || (CourtSystemErrorCode = {}));
